import React, { useState, useEffect } from "react";
import { Accordion, Spinner } from "react-bootstrap";
import { FAQService } from "../services";
import { handleConsoleError } from "../utils/common-methods";
import { toast } from "react-toastify";

const FAQComponent = (props) => {
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const res = await FAQService.getFAQList();
        if (res?.isSuccess) {
          const activeFAQs = res?.data?.filter((faq) => faq.isActive);
          setFilteredData(activeFAQs);
        }
        // else{
        //   toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
        // }
      } catch (error) {
        const message=handleConsoleError(error);
        toast.error(error?.message|| message);
      }
      setLoading(false);
    };

    getData();
  }, []);

  return (
    <>
      <section className="subscription-banner">
        <div className="container">
          <h3>FAQ</h3>
        </div>
      </section>

      <section className="faq-swollow">
        <div className="container">
          {loading ? (
            <Spinner animation="border" />
          ) : (
            <Accordion>
              {filteredData.map((faq, index) => (
                <Accordion.Item eventKey={index?.toString()} key={index}>
                  <Accordion.Header>{faq?.question}</Accordion.Header>
                  <Accordion.Body>{faq?.answer}</Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          )}
        </div>
      </section>
    </>
  );
};

export default FAQComponent;
